import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useAuthMutation } from '@packages/shared/src/hooks/useAuthMutation/useAuthMutation';
import { ForgotPasswordRequestEmailDocument } from '@packages/gql/generated/shopping/ForgotPasswordRequestEmailDocument';

/* GraphQL */ `
  mutation ForgotPasswordRequestEmail($payload: CustomerForgotPasswordRequestEmailRequestPayload!) {
    forgotPasswordRequestEmail(payload: $payload) {
      success
      accountHasNoPassword
      message
    }
  }
`;

const messages = defineMessages({
  generalError: {
    id: 'ForgotPasswordModal.request.generalError',
    defaultMessage:
      'Wir konnten Ihre Anfrage leider nicht bearbeiten. Versuchen Sie es später erneut.',
  },
});

export const useForgotPasswordRequestEmailGql = () => {
  const [error, setError] = useState<string | undefined>(undefined);
  const { formatMessage } = useIntl();
  const [{ fetching }, executeMutation] = useAuthMutation(ForgotPasswordRequestEmailDocument);

  const passwordForget = async (emailAddress: string): Promise<boolean> => {
    try {
      setError(undefined);
      const result = await executeMutation({ payload: { emailAddress } });
      if (result.error) {
        setError(formatMessage(messages.generalError));
        return false;
      }
      const forgotPasswordRequestEmail = result.data?.forgotPasswordRequestEmail;
      if (!forgotPasswordRequestEmail) {
        setError(formatMessage(messages.generalError));
        return false;
      }
      if (!forgotPasswordRequestEmail.success) {
        setError(forgotPasswordRequestEmail.message ?? formatMessage(messages.generalError));
        return false;
      }
      return true;
    } catch {
      setError(formatMessage(messages.generalError));
      return false;
    }
  };

  return {
    loading: fetching,
    error,
    passwordForget,
  };
};
